import React from 'react';
import LogoImg from '../../assets/images/logo.png';

const Logo = () => {
   return <img style={{
       width: '100%', height: '100%',
   }} src={LogoImg} alt="Logo-image"/>
}

export default Logo;